import { render } from "./InkLogo.vue?vue&type=template&id=263b3820&ts=true&lang=pug"
import script from "./InkLogo.vue?vue&type=script&lang=ts"
export * from "./InkLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__